import RegistryModule from "@/components/RegistryModule";
import { fmtDate } from "@/lib/api";
import { UserCheck } from "lucide-react";

export default function Visiteurs() {
  return (
    <RegistryModule
      kind="visitors"
      title="Registre des visiteurs"
      subtitle="Accueil & suivi des visites"
      icon={UserCheck}
      emptyForm={{ nom: "", organisation: "", motif: "", personne_visitee: "", heure_arrivee: "", heure_depart: "", notes: "", collaborateur_id: "", telephone: "" }}
      fields={[
        { key: "collaborateur_id", label: "Visiteur interne — sélectionner un collaborateur", type: "collaborator", span: 2, autofill: (e) => ({ nom: e.nom, organisation: "OMNIBAT ONE", telephone: e.telephone || "" }) },
        { key: "nom", label: "Nom du visiteur", required: true },
        { key: "organisation", label: "Organisation" },
        { key: "telephone", label: "Téléphone" },
        { key: "date", label: "Date", type: "date" },
        { key: "motif", label: "Motif de la visite", span: 2 },
        { key: "personne_visitee", label: "Personne visitée" },
        { key: "heure_arrivee", label: "Heure d'arrivée", type: "time" },
        { key: "heure_depart", label: "Heure de départ", type: "time" },
        { key: "notes", label: "Notes", type: "textarea", span: 2 },
      ]}
      columns={[
        { label: "Date", render: (r) => <span className="text-sm">{fmtDate(r.date)}</span> },
        { label: "Visiteur", render: (r) => <span className="font-medium">{r.nom}</span> },
        { label: "Organisation", render: (r) => <span className="text-sm text-slate-600">{r.organisation || "—"}</span> },
        { label: "Motif", render: (r) => <span className="text-sm text-slate-600">{r.motif || "—"}</span> },
        { label: "Reçu par", render: (r) => <span className="text-sm">{r.personne_visitee || "—"}</span> },
      ]}
    />
  );
}
